import type { Data, DataField } from '@urql/exchange-graphcache';

function getKey(...keys: DataField[]): string | null {
  if (keys.some((key) => key === null || key === undefined)) {
    return null;
  }

  return keys.join(':');
}

const keys: {
  [key: string]: (data: Data) => string | null;
} = {
  badge_aggregate: () => null,
  badge_aggregate_fields: () => null,
  badge_assignee_aggregate: () => null,
  badge_assignee_aggregate_fields: () => null,
  badge_assignee_attribute_aggregate: () => null,
  badge_assignee_attribute_aggregate_fields: () => null,
  badge_widget: (data) => getKey(data.event_id, data.team_id, data.person_id),
  chat_person: (data) => `${data.chat_id}:${data.person_id}`,
  chat_person_preference: (data) => `${data.chat_id}:${data.person_id}`,
  chat_person_aggregate: () => null,
  chat_person_aggregate_fields: () => null,
  configuration: (data) => `${data.kind}`,
  custom_tag_person_team: () => null,
  event_clock: (data) => `${data.event_id}`,
  event_team: (data) => getKey(data.event_id, data.team_id),
  event_min_fields: () => null,
  event_max_fields: () => null,
  event_all_participant: (data) => `${data.event_id}:${data.person_id}`,
  event_aggregate: () => null,
  event_aggregate_fields: () => null,
  event_path: (data) => `${data.event_id}:${data.parent_id}`,
  person_event_context: () => null,
  event_person: (data) => `${data.event_id}:${data.person_id}`,
  event_person_aggregate: () => null,
  event_permission_role: () => null,
  event_person_aggregate_fields: () => null,
  event_status: () => null,
  event_team_aggregate: () => null,
  event_team_aggregate_fields: () => null,
  event_team_management: (data) => getKey(data.event_id, data.team_id),
  event_team_rsvp_summary: (data) => getKey(data.event_id, data.team_id),
  event_team_standing: (data) => `${data.event_id}:${data.team_id}`,
  invite_code_rotation_result: () => null,
  invite_entry_acceptance_result: () => null,
  invite_entry_preview_result: () => null,
  message_aggregate: () => null,
  message_aggregate_fields: () => null,
  message_min_fields: () => null,
  person_aggregate: () => null,
  person_aggregate_fields: () => null,
  person_contact_access: () => null,
  person_manager: (data) => `${data.person_id}:${data.manager_id}`,
  person_tag_team: ({ person_id, tag_id, team_id }) =>
    `${person_id}:${tag_id}:${team_id}`,
  person_team_enrollment: (data) => getKey(data.person_id, data.team_id),
  person_team: (data) => `${data.person_id}:${data.team_id}`,
  rsvp_editor_access: () => null,
  rsvp: (data) => getKey(data.person_id, data.event_id),
  rsvp_aggregate: () => null,
  rsvp_aggregate_fields: () => null,
  team_permission_role: () => null,
  tag_group_team: (data) => `${data.tag_group_id}:${data.team_id}`,
  tag_group_team_aggregate: () => null,
  tag_group_team_aggregate_fields: () => null,
  person_team_aggregate: () => null,
  person_team_aggregate_fields: () => null,
  team_aggregate: (data) => data.__typename,
  team_aggregate_fields: (data) => data.__typename,
  standing: (data) => `${data.event_id}:${data.team_id}`,
};

export default keys;
